/* Keeps the product page entry total in step with the selected variant.

   Read-only. It never writes to the cart, the cart drawer or checkout, and
   it does not change how the product form submits. If this file fails to
   load the module still shows the correct total for the variant the server
   rendered.

   The numbers come from Liquid (snippets/giveaway-entries.liquid), so the
   browser only ever displays a figure the server already calculated. The
   campaign calendar is not present here. */
(function () {
  if (window.__gw26pdp) return;
  window.__gw26pdp = true;

  var reduceMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function fmt(n) {
    return Number(n).toLocaleString('en-US');
  }

  function rollTo(el, to) {
    var target = Number(to) || 0;
    var from = Number(String(el.textContent || '').replace(/[^\d]/g, '')) || 0;
    if (reduceMotion || from === target) {
      el.textContent = fmt(target);
      return;
    }
    var dur = 420;
    var start = 0;
    if (el._gwRaf) cancelAnimationFrame(el._gwRaf);
    function step(ts) {
      if (!start) start = ts;
      var t = Math.min(1, (ts - start) / dur);
      var eased = 1 - Math.pow(1 - t, 3);
      el.textContent = fmt(Math.round(from + (target - from) * eased));
      if (t < 1) el._gwRaf = requestAnimationFrame(step);
      else el.textContent = fmt(target);
    }
    el._gwRaf = requestAnimationFrame(step);
  }

  function init() {
    var root = document.querySelector('[data-gw-pdp]');
    if (!root) return;

    var dataNode = root.querySelector('[data-gw-pdp-variants]');
    var map = {};
    if (dataNode) {
      try { map = JSON.parse(dataNode.textContent); } catch (e) { map = {}; }
    }

    var entriesEl = root.querySelector('[data-gw-pdp-entries]');
    var baseEl = root.querySelector('[data-gw-pdp-base]');
    var last = null;

    /* The hidden input is whatever the product form will actually submit, so
       reading it covers every selector style on the page: kit cards, option
       dropdowns and swatches alike. */
    function currentId() {
      var tagged = document.querySelector('[data-variant-input]');
      if (tagged) return String(tagged.value || '');

      /* Product pages carry more than one form posting to /cart/add -- the
         frequently bought together bundle is one, and it comes first in the
         document. Fall back to the first candidate holding a variant of this
         product, so another product's form cannot drive this number. */
      var all = document.querySelectorAll('form[action*="/cart/add"] [name="id"]');
      for (var i = 0; i < all.length; i++) {
        var value = String(all[i].value || '');
        if (map[value]) return value;
      }
      return '';
    }

    function sync() {
      var id = currentId();
      if (!id || id === last) return;
      var row = map[id];
      if (!row) return;
      last = id;
      if (entriesEl) rollTo(entriesEl, row.entries);
      if (baseEl) baseEl.textContent = fmt(row.base);
    }

    sync();

    /* The product page updates the hidden input as a property rather than an
       attribute, so there is nothing for a MutationObserver to watch. Re-read
       after any interaction instead, then poll slowly as a backstop. */
    function nudge() {
      window.setTimeout(sync, 0);
      window.setTimeout(sync, 150);
    }
    document.addEventListener('click', nudge);
    document.addEventListener('change', nudge);
    window.setInterval(sync, 600);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
